// PRE RMA CSB — Droits d'accès aux modules des comptes Stock / Agent (réglés par l'administrateur).
// Conservés sur l'appareil pour fonctionner hors connexion ; le serveur applique de toute façon les mêmes règles.
import { api, getSession } from '../api/client.ts';
import { lireProfilJeton } from '../../../shared/business-logic/jeton.ts';

const CLE = 'prerma_modules';
export function lirePermissions(): string[] | null {
  try { const v = localStorage.getItem(CLE); return v ? (JSON.parse(v) as string[]) : null; } catch { return null; }
}
/** true pour un compte standard (aucun verrou) ou si le module est autorisé pour ce compte. */
export function moduleAutorise(code: string): boolean {
  // Le verrou ne concerne QUE les comptes à profil restreint (Stock / Agent), d'après le JETON réellement envoyé au serveur.
  // Admin et Responsable CSB : jamais verrouillés, même si des droits d'un ancien compte traînent dans le navigateur
  // (cause du menu qui disparaissait sous Chrome après expiration puis reconnexion avec un autre compte).
  const { token, role } = getSession();
  if (role === 'ADMIN' || !lireProfilJeton(token)) return true;
  const p = lirePermissions();
  return p === null || p.includes(code);
}
/** Oublie les droits mémorisés (changement de compte) : jamais de droits d'un ancien compte pour le nouveau. */
export function oublierPermissions(): void {
  localStorage.removeItem(CLE);
  localStorage.removeItem('prerma_profil');
}
export const profilCompte = (): string | null => lireProfilJeton(getSession().token) ?? null;
export async function chargerPermissions(): Promise<void> {
  try {
    const r = await api.get<{ profil: string | null; modules: string[] | null }>('/auth/permissions');
    if (r.modules) localStorage.setItem(CLE, JSON.stringify(r.modules)); else localStorage.removeItem(CLE);
    localStorage.setItem('prerma_profil', r.profil ?? '');
    window.dispatchEvent(new Event('prerma:permissions'));
  } catch { /* hors connexion : les droits mémorisés restent valables */ }
}
